module.exports = __webpack_public_path__ + "img/ico_biaoqianlongchong.66ae3635.png";